import { BasicFilterSelectField } from 'lib/iterable-hook-form/FormField/BasicFilterSelectField';
import { useAllowedCustomEventOptions } from 'utils/hooks/useCustomEvents';

/* 
  Drop down for selecting a conversion event, this component is used with react-hook-form as the state container.
*/

export const ConversionEventSelect = ({ id, isDisabled }: { id: string; isDisabled: boolean }) => {
  const customEventOptions = useAllowedCustomEventOptions();

  return (
    <BasicFilterSelectField
      id={'conversion-event'}
      name="conversions.event"
      placeholder={'Search or select conversion event'}
      options={customEventOptions}
      data-test={`${id}-form-custom-conversions-event`}
      isDisabled={isDisabled}
      isFullWidth={true}
    />
  );
};
